import { render, staticRenderFns } from "./_ModuleEntityPermissions.vue?vue&type=template&id=043a472e&scoped=true&"
import script from "./_ModuleEntityPermissions.vue?vue&type=script&lang=js&"
export * from "./_ModuleEntityPermissions.vue?vue&type=script&lang=js&"
import style0 from "./_ModuleEntityPermissions.vue?vue&type=style&index=0&id=043a472e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043a472e",
  null
  
)

export default component.exports